import React, { memo } from 'react'
import { CheckboxCategoryGroup } from '@pcln/filter'
import { Heading, Flex, Box, Divider, Text, Button } from 'pcln-design-system'
import { CarryOnBag, SeatEconomy, FreeCancellation } from 'pcln-icons'

import { Reset } from '../../AllOrNone'
import { EditAttributesFilters } from '../EditAttributesFilters/EditAttributesFilters'
import { useAttributeFilters } from '@mfs/client/listings-client/components/Filters/AttributesFilters/hooks/useAttributeFilters'

export const getFilterAttributes = (attributes) =>
  attributes.map((attr) => {
    attr = { ...attr }
    if (attr.value == 'CARRY_ON') {
      return {
        ...attr,
        primaryLabelIcon: <CarryOnBag size='16px' />,
      }
    }

    if (attr.value == 'SEATS') {
      return {
        ...attr,
        primaryLabelIcon: <SeatEconomy size='16px' />,
      }
    }

    if (attr.value == 'CHANGES') {
      return {
        ...attr,
        primaryLabelIcon: <FreeCancellation size='16px' />,
      }
    }

    return attr
  })

function AttributesFilters(props) {
  const { changeHandler, expandedMargin } = props
  const { attributes, isEditVisible, attributeHandleChange, resetClick } = useAttributeFilters({
    changeHandler,
  })

  const filterAttributes = getFilterAttributes(attributes)

  return (
    <Box bg='background.lightest' p={0} mb={expandedMargin ? '24px' : 3} borderRadius='lg'>
      <Flex mb={2} alignItems='center' justifyContent='space-between'>
        <Heading fontSize={2} bold>
          Inclusions
        </Heading>
        {!isEditVisible ? <Reset resetHandler={resetClick}>Reset</Reset> : null}
        {isEditVisible ? (
          <EditAttributesFilters>
            <Button variation='link'>
              <Text fontWeight='bold'>Reset</Text>
            </Button>
          </EditAttributesFilters>
        ) : null}
      </Flex>
      <Divider mb={3} mt={0} />
      <CheckboxCategoryGroup
        filters={filterAttributes}
        filterNamePrefix={'attributes'}
        handleChange={attributeHandleChange}
        className='flight-attribute-filters'
        wrapLabel={false}
        shouldPadConsistently
        isFilterCursorDisabled={isEditVisible}
      />
    </Box>
  )
}

export default memo(AttributesFilters)
